import CryptoJS from 'crypto-js';
import { env } from '../environment';

const SECRET_KEY = env.llaveMaestra;

export const encrypted = {
  // Encrypt a text using AES
  encrypt(text) {
    const parsedBase64Key = CryptoJS.enc.Base64.parse(SECRET_KEY);
    const iv = CryptoJS.lib.WordArray.random(16);
    const encryptedData = CryptoJS.AES.encrypt(text, parsedBase64Key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    // Prepend the IV to the encrypted text
    const ivAndCipherText = iv.concat(encryptedData.ciphertext).toString(CryptoJS.enc.Base64);
    return ivAndCipherText;
  },

  // Decrypt a text using AES
  decrypt(text) {
    const parsedBase64Key = CryptoJS.enc.Base64.parse(SECRET_KEY);
    const decodedText = CryptoJS.enc.Base64.parse(text);
    const iv = CryptoJS.lib.WordArray.create(decodedText.words.slice(0, 4));
    const cipherText = CryptoJS.lib.WordArray.create(decodedText.words.slice(4));
    const decryptedData = CryptoJS.AES.decrypt(
      { ciphertext: cipherText },
      parsedBase64Key,
      {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );
    const decryptedText = decryptedData.toString(CryptoJS.enc.Utf8);
    return decryptedText;
  },
};

// Token management utilities (can be used in non-React contexts)
export const tokenManager = {
  getToken: (tokenKey = "token") => {
    try {
      const encryptedToken = localStorage.getItem(tokenKey);
      if (!encryptedToken) return null;
      return encrypted.decrypt(encryptedToken);
    } catch (error) {
      console.error(`Error decrypting token ${tokenKey}:`, error);
      return null;
    }
  },

  setToken: (tokenValue, tokenKey = "token") => {
    try {
      if (!tokenValue) {
        localStorage.removeItem(tokenKey);
        return;
      }
      const encryptedToken = encrypted.encrypt(tokenValue);
      localStorage.setItem(tokenKey, encryptedToken);
    } catch (error) {
      console.error(`Error encrypting token ${tokenKey}:`, error);
    }
  },

  removeToken: (tokenKey = "token") => {
    localStorage.removeItem(tokenKey);
  },
};

// Session ID management utilities
export const sessionManager = {
  getSessionId: (sessionKey = "sessionId") => {
    try {
      const sessionId = localStorage.getItem(sessionKey);
      return sessionId || null;
    } catch (error) {
      console.error(`Error getting sessionId ${sessionKey}:`, error);
      return null;
    }
  },

  setSessionId: (sessionIdValue, sessionKey = "sessionId") => {
    try {
      if (!sessionIdValue) {
        localStorage.removeItem(sessionKey);
        return;
      }
      localStorage.setItem(sessionKey, sessionIdValue);
    } catch (error) {
      console.error(`Error setting sessionId ${sessionKey}:`, error);
    }
  },

  removeSessionId: (sessionKey = "sessionId") => {
    localStorage.removeItem(sessionKey);
  },
};